/* CarBreakers Europe v10 locale registry */
(function(w,d){
  var html=d.documentElement;
  var locale=(html.getAttribute('lang')||'en').toLowerCase().split('-')[0];
  var supported=['en','de','fr','es','it'];
  var active=supported.indexOf(locale)>-1?locale:'en';
  w.CarBreakersEurope=Object.freeze({
    version:'12.0.0',
    locale:active,
    requestedLocale:locale,
    supportedLocales:supported.slice(),
    root:(w.Shopify&&Shopify.routes&&Shopify.routes.root)||'/'
  });
  html.setAttribute('data-cb-locale',active);
  d.dispatchEvent(new CustomEvent('cb:locale-ready',{detail:w.CarBreakersEurope}));
})(window,document);
